"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var WindowImportValidationError_1 = require("../model/WindowImportValidationError");

var WindowImportErrorValidationConverter_1 = require("./WindowImportErrorValidationConverter");
/**
 * @author OPt
 */


var WindowImportValidationErrorConverterImpl =
/*#__PURE__*/
function (_WindowImportErrorVal) {
  _inherits(WindowImportValidationErrorConverterImpl, _WindowImportErrorVal);

  function WindowImportValidationErrorConverterImpl() {
    _classCallCheck(this, WindowImportValidationErrorConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(WindowImportValidationErrorConverterImpl).apply(this, arguments));
  }

  _createClass(WindowImportValidationErrorConverterImpl, [{
    key: "toDocument",

    /**
     * @inheritDoc
     */
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var document = {};
      Object.assign(document, {
        line: source.line,
        column: source.column,
        type: source.type,
        severity: source.severity
      });
      return document;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toObject",
    value: function toObject(source, conversions) {
      return new WindowImportValidationError_1.WindowImportValidationError(WindowImportValidationError_1.WindowImportValidationError.schema.line.valueOfField(source), WindowImportValidationError_1.WindowImportValidationError.schema.column.valueOfField(source), WindowImportValidationError_1.WindowImportValidationError.schema.type.valueOfField(source), WindowImportValidationError_1.WindowImportValidationError.schema.severity.valueOfField(source));
    }
  }]);

  return WindowImportValidationErrorConverterImpl;
}(WindowImportErrorValidationConverter_1.WindowImportValidationErrorConverter);

exports.WindowImportValidationErrorConverterImpl = WindowImportValidationErrorConverterImpl;